export const checkIfTestComplete = (accountSettings, moneyMgmtTestArr) => {
    let testRequired = false
    let testTypeArr=[]
    for (let i=0; i<moneyMgmtTestArr.length; i++){
        testTypeArr.push(moneyMgmtTestArr[i].testType);
    }
    if (accountSettings.testSettings){
        const testSettings = accountSettings.testSettings;
        if (testSettings.testType === "pre-test" &&
            testSettings.forceTest === true &&
            !testTypeArr.includes(testSettings.testType)){
                testRequired = true;
        }
    }
    return testRequired;
}
export default checkIfTestComplete;